import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';
import { API_URL } from '../config/api';



if (!API_URL) {
  throw new Error('API_URL is not defined! Check your environment configuration.');
}
//console.log('API_URL:', API_URL);
class AuthService {
  async login(email: string, password: string) {
    try {
      //console.log('API_URL:', API_URL);
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });

      // Check if user is verified
      if (response.data.user && response.data.user.isVerified === false) {
        throw new Error('Please verify your email before logging in.');
      }

      if (response.data.token) {
        await AsyncStorage.setItem('userToken', response.data.token);
        await AsyncStorage.setItem('userData', JSON.stringify(response.data.user));
      }

      return response.data;
    } catch (error: any) {
      if (error.response) {
        throw new Error(error.response.data.message || 'Login failed');
      } else {
        throw new Error(error.message || 'Network error. Please check your connection.');
      }
    }
  }

  async register(name: string, email: string, password: string, gradeLevel: string) {
    try {
      const response = await axios.post(`${API_URL}/auth/register`, {
        name,
        email,
        password,
        gradeLevel
      });
      //console.log('API_URL:', API_URL);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        throw new Error(error.response.data.message || 'Registration failed');
      } else {
        throw new Error('Network error. Please check your connection.');
      }
    }
  }

  async logout() {
    await AsyncStorage.removeItem('userToken');
    await AsyncStorage.removeItem('userData');
  }

  async getCurrentUser() {
    const userData = await AsyncStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  }

  async isLoggedIn() {
    const token = await AsyncStorage.getItem('userToken');
    return !!token;
  }

  // Add this function for the resource service
  async getAuthToken(): Promise<string | null> {
    return await AsyncStorage.getItem('userToken');
  }

  async resendVerificationEmail(email: string) {
    try {
      const response = await axios.post(`${API_URL}/auth/resend-verification`, { email });
      return response.data;
    } catch (error: any) {
      if (error.response) {
        throw new Error(error.response.data.message || 'Failed to resend verification email');
      } else {
        throw new Error('Network error. Please check your connection.');
      }
    }
  }

  async deleteAccount() {
    const token = await AsyncStorage.getItem('userToken');
    await axios.delete(`${API_URL}/users/me`, {
      headers: { 'x-auth-token': token },
    });
  }
}

export default new AuthService(); 